import { ThemeColors } from '../../../'

export interface TagInputColors {
  Background: ThemeColors
  FontColor: ThemeColors
  Icon: ThemeColors
}

export const tagInputColors: TagInputColors = {
  Background: {
    default: 'bg.emphasized',
  },
  FontColor: {
    default: 'fg.default',
  },
  Icon: {
    default: 'fg.default',
  },
}
